import CacheableJson from '../CacheableJson';
class News extends CacheableJson {
}

export default News;